module.exports = __webpack_public_path__ + "static/media/tiny-empty-coming-soon.48398245.svg";